<template>
    <kt-panel>

    <div class="fh-datatable" >
        <table class="table table-striped">
            <thead>
            <tr style="font-size: 0.89rem;">
                <td style="text-align: center; width:70px">#</td>
                <td style="text-align: center">{{ $t('security.full_name') }}</td>
                <td style="text-align: center">{{ $t('security.created_date') }}</td>
                <td style="text-align: center">{{ $t('security.ip') }}</td>
                <td style="text-align: center">{{ $t('datatable.actions') }}</td>
            </tr>
            </thead>
            <tbody  v-if="suspected_ips.length > 0">
            <tr v-bind:key="index" v-for="(user, index) in suspected_ips">
                <td style="text-align: center">{{ user.hashid }}</td>
                <td style="text-align: center">{{ user.full_name}}</td>
                <td style="text-align: center">{{ user.created_date}}</td>
                <td style="text-align: center">{{ user.ip }}</td>
                <td style="text-align: center">
                    <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
                        <i class="fa fa-cog"></i>
                    </button>
                    <div class="dropdown-menu">
                        <button
                                id="add_To_SuspectedIPs"
                                @click="deleteFromSuspectedIPs(user.hashid)"
                                class="dropdown-item"
                        >
                            {{ $t('security.blackList.deleteFromSuspectedIPs') }}
                        </button>
                        <button
                                id="add_To_BlackIPs"
                                @click="addToBlackIPs(user.hashid)"
                                class="dropdown-item"
                        >
                            {{ $t('security.blackList.addToBlackIPs') }}
                        </button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="loader" style="display:none"></div>
    </kt-panel>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {blackListService} from "@/common/api.service";
    import toastr from "toastr";
    import $ from "jquery";

    export default {

        computed: {
            ...mapGetters('blackList', ['suspected_ips', 'status']),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-top-left",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },
        mounted() {
            this.$store.dispatch('blackList/fetchSuspectedIps')
        },
        methods: {
            deleteFromSuspectedIPs(hashid) {
                $('.loader').addClass('disp_block')
                blackListService.deleteFromSuspectedIPs(hashid).then(response => {
                    this.$store.dispatch('blackList/fetchSuspectedIps')
                    this.toastr.success(response.data.message)
                    $('.loader').removeClass('disp_block')
                })
            },
            addToBlackIPs(hashid) {
                $('.loader').addClass('disp_block')
                blackListService.addToBlackIPs(hashid).then(response => {
                    this.$store.dispatch('blackList/fetchBlackIps')
                    this.toastr.success(response.data.message)
                    $('.loader').removeClass('disp_block')
                    this.$store.dispatch('blackList/fetchSuspectedIps')
                })
            }
        }
    }
</script>